export var EnrollmentStatus;
(function (EnrollmentStatus) {
    EnrollmentStatus["COMPLETED"] = "Conclu\u00EDdo";
    EnrollmentStatus["IN_PROGRESS"] = "Em andamento";
    EnrollmentStatus["NOT_STARTED"] = "N\u00E3o iniciado";
    EnrollmentStatus["EXPIRED"] = "Expirado";
    EnrollmentStatus["APPROVED"] = "Aproved";
})(EnrollmentStatus || (EnrollmentStatus = {}));
//# sourceMappingURL=EnrollmentCard.types.js.map